import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Article Sections',
  basePath: '/article-sections',
  columns: [
    { key: 'title', label: 'Title', sortable: true },
    { key: 'superior_label', label: 'Superior', sortable: true },
    { key: 'router_link_label', label: 'Router Link', sortable: true },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'superior', label: 'Superior', type: 'async-select',
      optionsUrl: '/article-superiors/options', allowClear: true },
    { key: 'router_link', label: 'Router Link', type: 'async-select',
      optionsUrl: '/router-links/options', allowClear: true },
  ],
  defaultSort: { field: 'title', dir: 'asc' },
});
